import { Injectable, TemplateRef, Type, ViewContainerRef } from '@angular/core';
import { ModalConfig } from 'src/app/modules/shared/modals/modal.config.interface';
import { Modal } from 'src/app/modules/shared/modals/modal.interface';
import { ModalHostDirective } from './modal.host.directive';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalHost: ModalHostDirective;

  get containerRef(): ViewContainerRef {
    return this.modalHost.viewContainerRef;
  }

  setHost(host: ModalHostDirective) {
    this.modalHost = host;
  }

  getHost(): ModalHostDirective {
    return this.modalHost;
  }

  createInstance<T extends Modal>(type: Type<T>, config: ModalConfig) {
    if (this.modalHost) {
      this.clearHost();
      const componentRef = this.containerRef.createComponent(type);
      const instance = componentRef.instance as T;
      instance.configure(config);
      return instance;
    }
    return null;
  }

  createTemplateInstance<T>(template: TemplateRef<T>, context: T): void {
    if (this.modalHost) {
      this.clearHost();
      this.containerRef.createEmbeddedView(template, context);
    }
  }

  clearHost(): void {
    this.containerRef.clear();
  }
}
